import { render, staticRenderFns } from "./AuthForm.vue?vue&type=template&id=a37c5362&scoped=true"
import script from "./AuthForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuthForm.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AuthForm.vue?vue&type=style&index=0&id=a37c5362&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a37c5362",
  null
  
)

export default component.exports